{
  "listingTableConfig": {
    "columns": [
    {
      "fieldName": "creditNoteDate",
      "displayName": "Credit Note Date",
      "dataType": "DATETIME",
      "thStyleConfig": {
        "width": "70px"
      }
    },
    {
      "fieldName": "sequenceNo",
      "displayName": "Invoice No.",
      "dataType": "STRING",
      "thStyleConfig": {
        "width": "80px"
      }
    },
    {
      "fieldName": "customer.name",
      "displayName": "Customer Name",
      "dataType": "STRING",
      "thStyleConfig": {
        "width": "170px"
      }
    },
    {
      "fieldName": "charge.name",
      "displayName": "Charge Name",
      "dataType": "STRING",
      "thStyleConfig": {
        "width": "170px"
      }
    },
    {
      "fieldName": "amount",
      "displayName": "Amount",
      "dataType": "NUMBER",
      "thStyleConfig": {
        "width": "30px"
      },
      "styleConfig": {
        "styleProperties": {
          "color": "var(--Brand-500, #1D7EDA)",
          "fontFamily": "Inter",
          "fontSize": "13px",
          "fontStyle": "normal",
          "fontWeight": "600",
          "lineHeight": "20px"
        }
      }
    },

    {
      "fieldName": "createdBy",
      "dbName": "created_by",
      "displayName": "Created By",
      "dataType": "STRING",
      "styleConfig": {
        "type": "user-avatar"
      }
    },
    {
      "fieldName": "createdDate",
      "dbName": "created_date",
      "displayName": "Created Date",
      "dataType": "DATETIME",
      "sortable": true
    }
  ]
  },
  "searchBarConfig": {
    "placeHolder": "Search credit note by invoice no",
    "filters": [
      {
        "name": "CREDIT_NO_EQUALS",
        "alias": "CREDIT_NO_EQUALS"
      }
    ]
  },
  "filterConfig": {
    "filterFields": [
      {
        "name": "invoiceNo",
        "displayLabel": "Invoice No",
        "dataType": "STRING",
        "operatorToFilterMap": {
          "EQ": "CREDIT_NO_EQUALS"
        }
      }
    ],
    "useNewContract": true
  }
}
